// extracted by mini-css-extract-plugin
export default {"right_wrapper":"RightBox_right_wrapper__kar3i","batch_btn":"RightBox_batch_btn__8U+tv","paging":"RightBox_paging__SaNCT"};